import React from "react";
import "../../../../css/pages/ca_pages/models/dashboard/DashboardHeader.css";

const DashboardHeader = () => {
    const today = new Date().toLocaleDateString("en-IN", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
    });

    return (
        <div className="caDashPro__header">
            {/* LEFT SIDE */}
            <div className="caDashPro__headerLeft">
                <h2 className="caDashPro__welcome">
                    Welcome back 👋
                </h2>

                <p className="caDashPro__subText">
                    Here's your work summary for {today}
                </p>
            </div>

            {/* CENTER SEARCH */}
            <div className="caDashPro__searchWrap">
                <input
                    className="caDashPro__searchInput"
                    placeholder="Search clients, businesses, invoices..."
                />
            </div>

            {/* RIGHT ACTIONS */}
            <div className="caDashPro__headerRight">
                <button className="caDashPro__iconBtn">
                    🔔
                </button>

                <button className="caDashPro__primaryBtn">
                    + Quick Add
                </button>
            </div>
        </div>
    );
};

export default DashboardHeader;
